import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';

@Component({
  selector: 'ui-loading-state',
  imports: [],
  templateUrl: './ui-loading-state.component.html',
  styleUrl: './ui-loading-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLoadingStateComponent {
  public readonly title: InputSignal<string> = input<string>('Loading');
  public readonly description: InputSignal<string | null> = input<string | null>(null);

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
}
